import factory from './icon';
import Svg24x24 from './glyphs/Error_24x24.svg';

export const Error8x8 = factory(Svg24x24, 8, 8);
export const Error12x12 = factory(Svg24x24, 12, 12);
export const Error16x16 = factory(Svg24x24, 16, 16);
